import 'core-js'
import * as React from 'react'
import VueWrapper from 'vue-wrapper'
import App from './app.vue'

/**
 *
 *
 * @param {string} page - create, show or index
 */
const getVueWrapper = function (page) {
    /**
     * The main app for the console jsx to react from vuew
     *
     * @param {object | null} props  - react props
     */
    // eslint-disable-next-line react/display-name
    return function (props) {
        return (
            <div>
                {VueWrapper({ ...props, page }, App)}
            </div>
        )
    }
}

/**
 * @param {object | null} props
 */
const AccountContact = getVueWrapper('account')

/**
 * @param {object | null} props
 */
const SystemSettings = getVueWrapper('system')

/**
 *
 */
export {
    SystemSettings,
    AccountContact
}
